/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Maximum_10Inputs */

const en_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum: 10`)
};

const fr_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum : 10`)
};

const de_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal: 10`)
};

const it_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massimo: 10`)
};

const ru_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимум: 10`)
};

const es_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo: 10`)
};

const zh_cn2_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多：10`)
};

const ja_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大: 10`)
};

const hi_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम: 10`)
};

const pt_pt2_options_backup_maximum_10 = /** @type {(inputs: Options_Backup_Maximum_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo: 10`)
};

/**
* | output |
* | --- |
* | "Maximum: 10" |
*
* @param {Options_Backup_Maximum_10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_maximum_10 = /** @type {((inputs?: Options_Backup_Maximum_10Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Maximum_10Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_maximum_10(inputs)
	if (locale === "de") return de_options_backup_maximum_10(inputs)
	if (locale === "it") return it_options_backup_maximum_10(inputs)
	if (locale === "ru") return ru_options_backup_maximum_10(inputs)
	if (locale === "es") return es_options_backup_maximum_10(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_maximum_10(inputs)
	if (locale === "ja") return ja_options_backup_maximum_10(inputs)
	if (locale === "hi") return hi_options_backup_maximum_10(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_maximum_10(inputs)
	return en_options_backup_maximum_10(inputs)
});